module.exports = "/images/Sweden.png?61070d2534357897fd6fb3c3d450916a";